import { render, staticRenderFns } from "./UpdateUserType.vue?vue&type=template&id=74a5c5a7&scoped=true&"
import script from "./UpdateUserType.vue?vue&type=script&lang=js&"
export * from "./UpdateUserType.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserType.vue?vue&type=style&index=0&id=74a5c5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5c5a7",
  null
  
)

export default component.exports